// KEEP IN SYNC WITH ExportTypeEnum.cs
enum ExportTypeEnum {
  Unknown = "Unknown",
  AdequacyServicingProvider = "adequacyServicingProvider",
  AdequacySummary = "adequacySummary",
  AdequacyAggregate = "adequacyAggregate",
  ExpansionOpportunity = "expansionOpportunity",
  SummariesDetail = "summariesDetail",
  HsdServicingProvider = "hsdServicingProvider",
  AdequacySummaryBulk = "adequacySummaryBulk",
  HsdServicingProviderBulk = "hsdServicingProviderBulk",
  AccuracyAggregate = "accuracyAggregate",
  AttestationAggregate = "attestationAggregate",
  AttestationSummary = "attestationSummary",
  AttestationServicingProvider = "attestationServicingProvider",
  CompositeAggregate = "compositeAggregate",
  CompositeSummary = "compositeSummary",
  CompositeServicingProvider = "compositeServicingProvider",
  AccuracyActionableProvider = "accuracyActionableProvider",
  ServicingProviderBulk = "servicingProviderBulk",
  AdequacyBulkTermination = "adequacyBulkTermination",
  AdequacyBulkTerminationBlob = "adequacyBulkTerminationBlob",
  ZipSummary = "zipSummary",
  AdequacyNextClosestProvider = "adequacyNextClosestProvider",
  HsdNextClosestProvider = "hsdNextClosestProvider",
  UserLoginStatistics = "userLoginStatistics",
  AdequacyBulkTarget = "adequacyBulkTarget",
  AdequacyBulkTargetBlob = "adequacyBulkTargetBlob",
  HsdMmpServicingProvider = "hsdMmpServicingProvider",
  HsdMmpNextClosestProvider = "hsdMmpNextClosestProvider",
  AccessReportsUsage = "accessReportsUsage",
  ClosestProvidersToMembers = "closestProvidersToMembers",
  PractitionerAtLocation = "practitionerAtLocation",
  Practitioner = "practitioner",
  ServiceLocation = "serviceLocation",
  AccuracyStatusReport = "accuracyStatusReport",
  CCIIOProvider = "cciioProvider",
  ZipSummaryBulk = "zipSummaryBulk",
  PciDashboardDetails = "pciDashboardDetails",
  PciCrossProject = "pciCrossProject",
  ZipAnalysisResultsReport = "zipAnalysisResultsReport",
  CCIIOPPFReport = "cciioPPFReport",
  CCIIOPPFBulkReport = "cciioPPFBulkReport",
  ZipClassAggregateResultsReport = "zipClassAggregateResultsReport",
  DistinctServicingProviderReport = "distinctServicingProviderReport",
  DistinctServicingProviderBulkReport = "distinctServicingProviderBulkReport",
  AdequacyBulkAggregateReport = "adequacyBulkAggregateReport",
  AdequacySpecialtySummary = "adequacySpecialtySummary",
  AdequacySpecialtySummaryBulk = "adequacySpecialtySummaryBulk",
  CmsExceptionReport = "cmsExceptionReport",
  CompetitiveInsightsDashboardDetails = "competitiveInsightsDashboardDetails",
  BulkSpecialtyGroupExceptionReport = "bulkSpecialtyGroupExceptionReport",
  ZipAnalysisAdequacyServicingProvider = "zipAnalysisAdequacyServicingProvider",
  StateSummary = "stateSummary",
  CountySummary = "countySummary",
  SpecialtySummaryByCounty = "specialtySummaryByCounty",
  StateSummaryComparison = "stateSummaryComparison",
  CountySummaryComparison = "countySummaryComparison",
  SpecialtySummaryByCountyComparison = "specialtySummaryByCountyComparison",
  ZipSummaryComparison = "zipSummaryComparison",
  AdequacySpecialtySummaryComparison = "adequacySpecialtySummaryComparison",
  CCIIOJustificationExport = "cciioJustificationExport",
  CCIIOProviderValidationSummary = "cciioProviderValidationSummary",
  CCIIOValidationDataIntegrity = "cciioValidationDataIntegrity",
  ProviderExport = "providerExport",
  AdequacyAggregateComparison = "adequacyAggregateComparison",
  AdequacyServicingProviderComparison = "adequacyServicingProviderComparison",
  ZipAnalysisAdequacyServicingProviderComparison = "zipAnalysisAdequacyServicingProviderComparison",
  ZipClassAggregateResultsReportComparison = "zipClassAggregateResultsReportComparison",
  ProviderHubServicingProviderReport = "providerHubServicingProviderReport",
  AdequacyBulkTerminationSpecialtySummaryComparison = "adequacyBulkTerminationSpecialtySummaryComparison",
  AdequacyBulkTerminationChangedGaps = "adequacyBulkTerminationChangedGaps",
  AdequacyBulkTerminationProviders = "adequacyBulkTerminationProviders",
  AdequacyBulkTerminationVolumeTermProjectDetails = "adequacyBulkTerminationVolumeTermProjectDetails",
  AdequacyBulkTerminationDistinctProviders = "adequacyBulkTerminationDistinctProviders",
  MultiMapExport = "multiMapExport",
}

export { ExportTypeEnum };